<template>
  <div>
    <app-cells><h1 class="title">Finance dictionaries</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FinanceDictionaries',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-dictionaries-banks', label: 'Banks'},
        { name: 'finance-dictionaries-items', label: 'Transaction items'},
        { name: 'finance-dictionaries-item-groups', label: 'Transaction item groups'},
      ],
    }
  },
}
</script>
